var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-stepper",
    {
      model: {
        value: _vm.step,
        callback: function ($$v) {
          _vm.step = $$v
        },
        expression: "step",
      },
    },
    [
      _c(
        "v-stepper-header",
        { staticClass: "elevation-0" },
        [
          _c("v-stepper-step", { attrs: { id: "step-1", step: "1" } }, [
            _vm._v(" Tenable Authorization "),
          ]),
          _c("v-divider"),
          _c("v-stepper-step", { attrs: { id: "step-2", step: "2" } }, [
            _vm._v(" Search Scan Results "),
          ]),
        ],
        1
      ),
      _c(
        "v-stepper-items",
        [
          _c(
            "v-stepper-content",
            { attrs: { step: "1" } },
            [
              _c("AuthStep", {
                on: {
                  authenticated: _vm.onAuthenticationComplete,
                  error: function ($event) {
                    _vm.errorCount += 1
                  },
                  "show-help": function ($event) {
                    _vm.errorCount = -1
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-stepper-content",
            { attrs: { step: "2" } },
            [
              _vm.tenableConfig
                ? _c("FileList", {
                    attrs: { "tenable-config": _vm.tenableConfig },
                    on: { signOut: _vm.onSignOut, "got-files": _vm.got_files },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-overlay",
        {
          attrs: {
            opacity: 50,
            absolute: "absolute",
            value: _vm.errorCount >= 3 || _vm.errorCount < 0,
          },
        },
        [
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "p",
                [
                  _vm.errorCount > 0
                    ? _c(
                        "span",
                        {
                          staticStyle: { color: "red", "font-weight": "bold" },
                        },
                        [
                          _vm._v(
                            " It seems you may be having trouble connecting to Tenable.sc. Ensure "
                          ),
                          _c("br"),
                          _vm._v(
                            " that the access key, secret key, and host url are properly configured. "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c("br"),
                  _c("span", [
                    _vm._v(
                      " For connection instructions and further information, consult: "
                    ),
                  ]),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        target: "_blank",
                        href: "https://github.com/mitre/heimdall2#tenablesc",
                        text: "",
                        color: "info",
                        "px-0": "",
                      },
                    },
                    [
                      _c("v-icon", { attrs: { "pr-2": "" } }, [
                        _vm._v("mdi-github-circle"),
                      ]),
                      _vm._v(" Tenable Configuration "),
                    ],
                    1
                  ),
                  _c("br"),
                  _c("span", [
                    _vm._v(
                      " API key authorization requires Tenable.sc 5.13.x or later. "
                    ),
                    _c("br"),
                    _vm._v(
                      " A unique set of API keys can be generated for each user account. "
                    ),
                    _c("br"),
                    _vm._v(
                      " The API authorization keys serve as a user authentication token. "
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "info" },
                  on: {
                    click: function ($event) {
                      _vm.errorCount = 0
                    },
                  },
                },
                [_vm._v(" Ok ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }